import React, { Component } from "react";
import $ from "../../utils/jquery";
import ComponentHasTranslations from "../../utils/component_has_translations";

class ShareForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      message: {},
      input: "",
    };
  }

  maxInputLength = 175;
  minInputLength = 10;

  setInput = (ev) => {
    this.resetForm();
    this.setState({ input: ev.target.value });
  };

  resetForm = () => {
    this.setState({
      submitting: false,
      submitted: false,
      message: {},
    });
  };

  inputIsValid = () =>
    this.state && this.state.input.length > this.minInputLength;

  inputLengthClass = () => {
    const l = this.state.input.length;

    if (l > 0 && l <= this.minInputLength) {
      return "too-short";
    } else if (l > this.minInputLength && l < this.maxInputLength) {
      return "long-enough";
    } else if (l == this.maxInputLength) {
      return "max";
    }
  };

  submit = (ev) => {
    this.setState({ submitting: true });

    $.ajax({
      url: "/how_use_items",
      type: "POST",
      data: {
        comment: this.state.input,
        context: this.props.context,
      },
      xhrFields: {
        withCredentials: true,
      },
    })
      .done((data) => {
        if (data.status == "success") {
          this.setState({ submitted: true });
        } else {
        }
        this.setState({ message: data });
      })
      .fail((jqXHR) => {
        this.setState({
          submitting: false,
          message: {
            status: "failed",
            message:
              "There was a problem saving your submission. Please try again later. We're sorry for the inconvenience.",
          },
        });
      })
      .always(() => this.setState({ submitting: false }));
  };

  submitControls = () => {
    if (this.state.submitting) {
      return this.spinner;
    } else if (this.state.submitted) {
      return null;
    } else {
      return this.submitButton();
    }
  };

  submitButton = () => (
    <button
      className="btn btn-primary form-control mb-3"
      onClick={this.submit}
      disabled={!this.inputIsValid()}
    >
      <i className="fa fa-comments"></i>
      &nbsp;
      {this.tr("share_form.submit_btn_text")}
    </button>
  );

  spinner = (<i className="fas fa-spinner fa-spin fa-2x "></i>);

  statusToMessageClassMap = {
    success: "success",
    failed: "danger",
  };

  message = () => {
    const m = this.state.message;
    const c = this.statusToMessageClassMap[m.status];

    if (m.status) {
      return (
        <>
          <div className={`alert alert-${c}`}>{m.message}</div>
          {this.links()}
        </>
      );
    }
  };

  links = () => {
    if (this.props.tr["share_form.counting_heartbeats"]) {
      return (
        <div className="text-center">
          <div className="row gy-3 mb-3 text-center">
            <div className="col-6">
              {this.tr("share_form.counting_heartbeats")}
            </div>
            <div className="col-6">{this.tr("share_form.improve_bpm")}</div>
            <div className="col-6">
              <a
                className="btn btn-warning btn-sm"
                target="_blank"
                href="//www.tapheartrate.com"
              >
                <i className="fas fa-heart-pulse"></i> TapHeartrate.com
              </a>
            </div>
            <div className="col-6">
              <a
                className="btn btn-warning btn-sm"
                target="_blank"
                href="/en/guess_bpm/play"
              >
                <i className="fas fa-gamepad"></i> Guess BPM game
              </a>
            </div>
          </div>
        </div>
      );
    }
  };

  form = () => (
    <div>
      <p> {this.tr("share_form.intro")} </p>

      <div className="mb-2">
        <div id="input-count">
          <span id="input-length" className={this.inputLengthClass()}>
            {this.state.input.length}
          </span>{" "}
          / {this.maxInputLength}
        </div>
        <textarea
          className="form-control mb-1"
          id="comment"
          type="text"
          rows={4}
          maxLength={this.maxInputLength}
          value={this.state.input}
          placeholder={this.tr("share_form.placeholder")}
          onChange={(ev) => this.setInput(ev)}
          disabled={this.state.submitted || this.state.submitting}
          required
        />
      </div>

      <p className="center">{this.submitControls()}</p>

      {this.message()}
    </div>
  );

  render = () => {
    return <div id="how_use">{this.form()}</div>;
  };
}

Object.assign(ShareForm.prototype, ComponentHasTranslations);
export default ShareForm;
